export default "__VITE_ASSET__CtPSgbMU__"